const STATUS_LABELS: Record<string, string> = {
  pending: "排队中",
  running: "运行中",
  stopping: "正在停止",
  paused: "已暂停",
  retry_wait: "等待重试",
  scheduled: "定时等待",
  completed: "已完成",
  partial: "部分完成",
  incomplete: "未完成",
  ai_unavailable: "AI 分析暂不可用，已停止",
  failed: "失败",
  dead_letter: "多次失败已停止",
  cancelled: "已取消",
  terminated: "已终止",
  uncontacted: "未联系",
  contacted_waiting_reply: "已触达待回复",
  replied_waiting_human: "已回复待人工",
  human_handling: "人工处理中",
  stop_contact: "停止联系",
  deferred: "稍后提醒",
  resolved: "已处理",
  unrecognized: "无法识别",
  not_verified: "尚未通过复检",
  assigned: "已分配",
  contacting: "沟通中",
  replied: "已回复",
  invalid: "无效",
  normal: "正常",
  login_required: "需要登录",
  verification_required: "需要验证",
  risk_controlled: "风险受限",
  offline: "离线",
  missing: "未检测到 USB",
  disabled: "已停用",
  cooldown: "冷却中",
  online: "在线",
  manual_takeover: "人工控制中",
  busy: "忙碌",
  error: "异常",
  sent: "已发送",
  not_started: "未开始",
  submitted: "已提交",
  already_friend: "已是好友",
  not_found: "未找到微信",
  restricted: "不可添加",
  network_unavailable: "网络异常已跳过",
  simulated_submitted: "演示已提交",
  skipped: "已跳过",
  skipped_duplicate: "已拦截重复",
  skipped_unavailable: "账号/设备不可用",
  opening_profile: "打开主页",
  opening_conversation: "打开会话",
  pre_send_check: "发送前检查",
  prepared: "演练完成",
  sending: "正在发送",
  post_send_evidence: "已留存证据",
  waiting_login: "等待登录",
  waiting_human: "等待人工确认",
  waiting_codex: "AI中控诊断中",
  diagnosing: "诊断中",
  blocked: "已阻塞",
  result_unknown: "结果未知",
  unauthorized: "未授权",
  unbound: "未绑定",
  connected: "已连接",
  ready: "已就绪",
  configured: "已配置",
  unconfigured: "未配置",
  untested: "尚未测试",
  not_installed: "未安装",
  unavailable: "不可用",
  degraded: "部分可用",
  waiting_for_mode: "等待运行模式",
  approval_required: "发送前需审批",
  wiring_pending: "待接线",
  model_not_open: "模型未开通",
  timeout: "连接超时",
  live: "真实数据",
  demo: "演示数据",
  test: "测试数据",
  do_not_contact: "不联系",
  success: "成功",
  queued: "等待执行",
  active: "正在执行",
  done: "已结束",
};

const TYPE_LABELS: Record<string, string> = {
  mobile_social_workflow: "社媒获客",
  server_friend_pipeline: "微信添加好友",
  message_patrol: "消息巡检",
  simulation_browse: "仿真浏览",
  xiaohongshu: "小红书",
  douyin: "抖音",
  wechat_channels: "视频号",
  wechat: "微信",
};

const EVENT_LABELS: Record<string, string> = {
  "task.created": "任务已创建",
  "task.started": "任务开始执行",
  "task.progress": "任务进度更新",
  "task.completed": "任务已完成",
  "task.failed": "任务执行失败",
  "task.dead_letter": "任务多次失败，已停止重试",
  "task.retry_scheduled": "任务将在稍后自动重试",
  "task.duration_limit_reached": "已达到最长执行时间，保留已完成结果",
  "patrol.starting": "开始巡检消息",
  "patrol.locating_inbox": "正在定位消息列表",
  "patrol.returning_to_top": "正在返回最新消息位置",
  "patrol.closing_top_drawer": "已到顶部，正在返回聊天列表",
  "patrol.inbox_checked": "已检查一页消息列表",
  "patrol.conversation_read": "已读取新消息并加入客户回复",
  "patrol.conversation_checked": "已核查未读会话内容",
  "patrol.scan_finished": "本轮消息列表检查结束",
  "patrol.completed": "巡检结束",
  "patrol.entry_timeout": "执行时间已到，消息列表尚未检查",
  "screen.recognized": "手机页面识别证据已保存",
  "mobile.waiting_human": "手机页面需要人工处理",
  "task.paused": "任务已暂停",
  "task.pause": "任务已暂停",
  "task.resume": "任务已恢复",
  "task.resumed": "任务已恢复",
  "task.stop": "任务已终止",
  "task.terminate": "任务已终止",
  "task.terminated": "任务已终止",
  "task.claimed": "任务开始执行",
  "queue.enqueued": "已加入手机队列",
  "simulation.safe_browse": "已检查浏览页面",
  "simulation.like_attempt": "正在尝试点赞",
  "simulation.like_policy": "已启用浏览与适量点赞",
  "simulation.like_confirmed": "已确认点赞成功",
  "simulation.like_skipped": "本条内容跳过点赞",
  "simulation.like_unknown": "点赞结果未确认，未重试",
  "simulation.completed": "浏览任务结束",
  "simulation.step_completed": "已完成一轮浏览",
  "simulation.stopped": "任务已终止",
  "task.approved": "目标批次已批准",
  "wechat.target_finished": "微信目标处理完成",
  "outreach.waiting_allowed_window": "等待允许运行时段",
  "outreach.recovered_unknown": "中断记录转为待人工确认",
  "social.candidates_loaded": "社媒候选已读取",
  "crawl.started": "网页内容读取开始",
  "crawl.completed": "网页内容读取完成",
  "provider.search_started": "真实来源搜索开始",
  "provider.search_completed": "真实来源搜索完成",
  "provider.search_failed": "真实来源搜索失败",
  "decision.plan_started": "独立核心开始执行",
  "decision.provider_fallback": "模型不可用，已切换本地规则",
  "decision.analysis_completed": "独立核心已完成结果分析",
  "codex.plan_started": "AI中控开始制定恢复计划",
  "codex.plan_completed": "AI中控已选择受控步骤",
  "executor.web_read_completed": "只读网页执行器已返回证据",
  "executor.xiaohongshu_search_completed": "小红书受控执行器已返回候选",
  "xiaohongshu.profile_captured": "小红书博主主页与截图已保存",
  "executor.xiaohongshu_results_persisted": "小红书筛选结果已写入线索库",
  "codex.analysis_completed": "AI中控已完成证据分析",
};

export function statusLabel(value: string): string {
  return STATUS_LABELS[value] ?? value;
}

export function typeLabel(value: string | null): string {
  if (!value) return "-";
  return TYPE_LABELS[value] ?? value;
}

export function eventLabel(value: string): string {
  return EVENT_LABELS[value] ?? value;
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  const now = new Date();
  return new Intl.DateTimeFormat("zh-CN", {
    timeZone: "Asia/Shanghai",
    ...(date.getFullYear() !== now.getFullYear()
      ? { year: "numeric" as const }
      : {}),
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}

export function toShanghaiDateTimeInput(
  value: string | null | undefined,
): string {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat("en-CA", {
      timeZone: "Asia/Shanghai",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    })
      .formatToParts(date)
      .filter((part) => part.type !== "literal")
      .map((part) => [part.type, part.value]),
  );
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
}

export function shanghaiDateTimeInputToIso(value: string): string | null {
  const normalized = value.trim();
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?$/.test(normalized))
    return null;
  const date = new Date(
    `${normalized}${normalized.length === 16 ? ":00" : ""}+08:00`,
  );
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
}

export function statusTone(
  value: string,
): "success" | "warning" | "danger" | "info" | "neutral" {
  if (
    [
      "completed",
      "normal",
      "online",
      "ready",
      "connected",
      "configured",
      "sent",
      "submitted",
      "simulated_submitted",
      "already_friend",
      "replied",
      "live",
      "success",
      "enabled",
    ].includes(value)
  )
    return "success";
  if (
    [
      "paused",
      "cooldown",
      "partial",
      "incomplete",
      "login_required",
      "verification_required",
      "model_not_open",
      "retry_wait",
      "contacting",
      "contacted_waiting_reply",
      "replied_waiting_human",
      "human_handling",
      "deferred",
      "result_unknown",
      "network_unavailable",
      "waiting_human",
      "waiting_login",
      "skipped_duplicate",
      "skipped_unavailable",
      "unauthorized",
      "approval_required",
      "wiring_pending",
      "missing",
      "blocked",
    ].includes(value)
  )
    return "warning";
  if (
    [
      "failed",
      "ai_unavailable",
      "dead_letter",
      "error",
      "cancelled",
      "invalid",
      "risk_controlled",
      "restricted",
      "do_not_contact",
      "stop_contact",
      "unrecognized",
    ].includes(value)
  )
    return "danger";
  if (
    [
      "running",
      "stopping",
      "pending",
      "queued",
      "scheduled",
      "active",
      "assigned",
      "waiting_codex",
      "diagnosing",
    ].includes(value)
  )
    return "info";
  return "neutral";
}
